import { FormattedMessage } from 'react-intl';

import { IconTick } from '@xing-com/icons';

import { useDeckCardTyped } from '../../context';
// import { useDreamTracking } from '@xing-com/crate-dream-machine-tracking';

import { type PeakAndPopType } from './peak-and-pop';
import Styles from './peak-and-pop-company.style';

type KununuType = {
  href?: string;
  children: React.ReactNode;
};

const Kununu: React.FC<KununuType> = ({ href, children }) => {
  if (href) {
    return (
      <Styles.KununuAnchor href={href} target="_blank">
        {children}
      </Styles.KununuAnchor>
    );
  }
  return <Styles.KununuDiv>{children}</Styles.KununuDiv>;
};

export const PeakAndPopCompany: React.FC<PeakAndPopType> = ({ ...props }) => {
  // const { trackOpenCompany } = useDreamTracking();
  const { data } = useDeckCardTyped(['TakenJob', 'AvailableJob'] as const);
  const logoImage = data?.company?.logos?.logo256px;
  const industry = data?.company?.industry?.localizationValue;
  const aboutus =
    data?.company?.aboutUsBatched?.__typename === 'AboutEntity'
      ? data?.company?.aboutUsBatched
      : null;
  const slug = data?.company?.entityPage?.slug;
  const url = slug
    ? `/pages/${slug}?sc_o=jobs_dream_job_reco_company_logo_name_click&sc_o_PropActionOrigin=jobs_dream_job_status_${data.type === 'AvailableJob' ? 'available' : 'taken'}`
    : undefined;
  const kununuData = data?.company?.kununuData;

  const handleClick = (e: React.MouseEvent, url: string): void => {
    // trackOpenCompany({
    //   cardType: 'job_reco',
    //   status: data?.type,
    //   itemUrn: data?.urn || undefined,
    //   trackingToken: data?.trackingToken || undefined,
    // });
    window.open(url, '_blank');
  };

  const getKununuUrl = (): string | undefined => {
    if (kununuData?.companyProfileUrl) {
      return (
        kununuData?.companyProfileUrl +
        '?utm_source=xing_dream_machine&utm_medium=affiliate&utm_content=view_profile&rfr=xing_dream_machine_view_profile'
      );
    }
    return undefined;
  };

  return (
    <Styles.PeakAndPop {...props}>
      <Styles.Logo src={logoImage || undefined} size="medium" type="company" />
      <Styles.Title size="medium">{data?.company?.companyName}</Styles.Title>
      {industry && (
        <Styles.Marker
          variant={data.matchJobPreferredIndustry ? 'match' : undefined}
          icon={data.matchJobPreferredIndustry ? IconTick : undefined}
          ellipsis
        >
          {industry}
        </Styles.Marker>
      )}
      {kununuData?.ratingAverage && kununuData.ratingCount && (
        <Kununu href={getKununuUrl()}>
          <Styles.KununuRating>
            <Styles.KununuRatingValue size="small">
              {kununuData?.ratingAverage}
            </Styles.KununuRatingValue>
            <Styles.KununuRatingStars
              rating={kununuData?.ratingAverage}
              noValue
            />
          </Styles.KununuRating>
          <Styles.KununuReviewsCount size="xsmall">
            <FormattedMessage
              id={'DREAM_MACHINE_JOB_CARD_KUNUNU_REVIEWS_WEB'}
              values={{
                count: kununuData.ratingCount,
              }}
            />
          </Styles.KununuReviewsCount>
        </Kununu>
      )}
      <Styles.About>
        {aboutus?.aboutHeadline && (
          <Styles.AboutHeadline size="small">
            {aboutus?.aboutHeadline}
          </Styles.AboutHeadline>
        )}
        {aboutus?.aboutSummary && (
          <Styles.AboutSummary size="small">
            {aboutus?.aboutSummary}
          </Styles.AboutSummary>
        )}
      </Styles.About>
      {url && (
        <Styles.ActionContainer>
          <Styles.Action
            variant="secondary"
            size="medium"
            onClick={(e) => handleClick(e, url)}
          >
            <FormattedMessage id="DREAM_MACHINE_JOB_CARD_COMPANY_TILE_CTA" />
          </Styles.Action>
        </Styles.ActionContainer>
      )}
    </Styles.PeakAndPop>
  );
};
